<template>
  <v-card class="px-3 pb-5 half-radius">
    <v-card-title class="custom-text py-1">
      <v-btn v-if="closable" icon @click="$emit('input', false)">
        <v-icon color="#29284c">mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer />
      <slot name="title">
        <v-btn class="text-capitalize" color="#29284c" text @click="uploadAudioFile">
          Upload Audio
          <v-icon right color="#29284c" style="transform: rotateX(180deg)">
            $vuetify.icons.appDownload
          </v-icon>
        </v-btn>
      </slot>
    </v-card-title>
    <slot name="title-text" />
    <div class="px-2">
      <div
        class="comment__editor px-3"
        :style="noIncrease ? '' : 'min-height: 200px'"
        @click="onFocus"
      >
        <app-editor v-model="comment.text" ref="editor" :editable="!content" @click.native.stop />
      </div>
    </div>
    <v-card-actions class="pt-7 pb-3">
      <app-record-button :recording="recording" @click="onRecord" />
      <v-fade-transition>
        <app-time-stamp
          v-if="timeStamp && !$vuetify.breakpoint.xs"
          :time="timeStamp"
          :recording="recording"
          >{{ formatTime(timeStamp) }}</app-time-stamp
        >
      </v-fade-transition>
      <v-fade-transition>
        <app-remove-button v-if="!recording && audioUrl" @click="removeAudio" />
      </v-fade-transition>
      <div class="pb-9">
        <div class="absolute">
          <app-button-player
            class="ml-4"
            v-if="computedSrc"
            :src="computedSrc"
            :class="{ commenting: commentDialog, fade: !commentDialog }"
          />
        </div>
      </div>
      <v-spacer />
      <app-create-button
        v-model="snackbar"
        :disabled="recording || !!disabled"
        @click="create"
        :snackbarText="snackbarText"
      />
    </v-card-actions>
  </v-card>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import RecordButton from "@/components/Lessons/Lesson/components/RecordButton.vue";
import RemoveButton from "@/components/Lessons/Lesson/components/RemoveButton.vue";
import CreateButton from "@/components/Lessons/Lesson/components/CreateButton.vue";
import TimeStamp from "@/components/Lessons/Lesson/components/TimeStamp.vue";
import audioMixin from "@/mixins/audioMixin";
import ButtonPlayer from "./ButtonPlayer.vue";

export default {
  components: {
    appEditor: Editor,
    appRecordButton: RecordButton,
    appRemoveButton: RemoveButton,
    appCreateButton: CreateButton,
    appTimeStamp: TimeStamp,
    appButtonPlayer: ButtonPlayer,
  },
  props: {
    closable: {
      required: false,
      default: true,
      type: Boolean,
    },
    content: String,
    src: String,
    disabled: Boolean,
    commentDialog: Boolean,
    noIncrease: Boolean,
    showPlaceholder: Boolean,
  },
  mixins: [audioMixin],
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      comment: {
        text: null,
      },
      defaultContent: () => ({
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: this.showPlaceholder ? "Type your answer here (if applicable)..." : "",
              },
            ],
          },
        ],
      }),
    };
  },
  computed: {
    computedSrc() {
      if (this.src) {
        return this.src;
      } else if (this.audioUrl) {
        return this.audioUrl;
      } else if (this.audioBlob) {
        return this.audioBlob;
      } else return "";
    },
  },
  methods: {
    async create() {
      this.comment.audio = this.audioUrl;
      this.comment.audioBlob = this.audioBlob;
      const profile = this.$store.getters.profile;
      this.comment.teacher_name = `${profile.first_name} ${profile.last_name}`;
      this.$emit("new-comment", this.comment);
    },
    reset() {
      if (this.recording) {
        this.onRecord();
      }
      setTimeout(() => {
        this.comment = {};
        this.comment.text = this.defaultContent();
        this.$refs.editor.editor.setContent(this.comment.text);
        this.removeAudio();
      }, 300);
    },
    onFocus() {
      this.$refs.editor.editor.focus("end");
    },
  },
  watch: {
    content(value) {
      if (value) {
        this.comment.text = JSON.parse(value);
      }
    },
  },
  created() {
    if (this.content) {
      this.comment.text = JSON.parse(this.content);
    } else {
      this.comment.text = this.defaultContent();
    }
  },
};
</script>
<style scoped lang="scss">
.comment__editor {
  border: 1px #949494 solid;
  border-radius: 4px;
}
</style>
